import React from 'react';
import { Button, Checkbox, Row, Col } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { FieldGroup } from './FieldGroup';
import { Validator } from './Validator';
import { required} from '../utils/ValidatorRulesUtils';

const rules = [required];

export const BranchItem = observer(({ item, saveBranchItem, updateBranchItem }) => {
  const updateItem = (name, event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    updateBranchItem(item.id, name, value);
  }
  const save = () => {
    saveBranchItem(item.id)
  }
  return (
    <Row>
      <Col md={3}>
        <Validator rules={rules}
          fieldName='branchName' value={item.name} render={({ isValid, message }) => (
            <FieldGroup
              label='Branch Name'
              type='text'
              value={item.name || ''}
              onChange={updateItem.bind(this, 'name')}
              isValid={isValid}
              message={message}
              required
            />
      )} />
      </Col>
      <Col md={3}>
        <Validator rules={rules}
          fieldName='branchRefId' value={item.branchRefId} render={({ isValid, message }) => (
            <FieldGroup
              label='Branch Id'
              type='text'
              value={item.branchRefId || ''}
              onChange={updateItem.bind(this, 'branchRefId')}
              isValid={isValid}
              message={message}
              required
            />
          )} />
      </Col>
      <Col md={1} style={{marginTop: "25px"}}>
        <Button bsStyle='success' onClick={save}>Save</Button>
      </Col>
    </Row>
  );
});